/**
 * NI-25 — the portfolio review's words and numbers, apart from the card so
 * jest can call them (it cannot resolve the card's ui/ imports).
 *
 * Every figure here is Northline's, read from the facts the review was
 * written about; the model's words never carry an amount.
 */
import { moneyCents } from '../properties/varianceInvestigation';

export const STATE_LABEL = {
  queued: 'Review requested — Northline is starting it.',
  running: 'Northline is reviewing the portfolio…',
  refused: 'The last review was not published',
  failed: 'The last review failed',
  skipped: 'The last review did not run',
};

/** "2 of 5 properties off plan · $18,400 unfavorable · 61% of it at one property" */
export function totalsLine(totals) {
  if (!totals) return '';
  const parts = [`${totals.off_plan} of ${totals.in_scope} propert${totals.in_scope === 1 ? 'y' : 'ies'} off plan`];
  if (totals.exposure_cents) parts.push(`${moneyCents(totals.exposure_cents)} unfavorable`);
  if (totals.noi_unfavorable) parts.push(`NOI behind at ${totals.noi_unfavorable}`);
  if (totals.largest_share_pct != null && totals.off_plan > 1) {
    parts.push(`${Math.round(totals.largest_share_pct)}% of it at one property`);
  }
  return parts.join(' · ');
}

/** One property's line under its rank: what Northline measured there. */
export function propertyLine(p) {
  if (!p) return '';
  const parts = [`${p.issue_count} variance${p.issue_count === 1 ? '' : 's'}`];
  if (p.exposure_cents) parts.push(`${moneyCents(p.exposure_cents)} unfavorable`);
  if (p.noi_unfavorable) parts.push('NOI behind plan');
  if (p.largest_unfavorable) parts.push(`largest: ${p.largest_unfavorable}`);
  return parts.join(' · ');
}

/** "NOI (budget) — unfavorable at 3 properties, $12,000 in all" */
export function patternLine(p) {
  if (!p) return '';
  const amount = p.amount_cents ? `, ${moneyCents(p.amount_cents)} in all` : '';
  return `${p.label} — ${p.direction} at ${p.property_count} properties${amount}`;
}

/** Why there is nothing to ask for yet, or '' when there is. */
export function tooFewLine(data) {
  if (!data || data.properties_in_scope == null) return '';
  const min = data.min_properties || 2;
  if (data.properties_in_scope >= min) return '';
  const n = data.properties_in_scope;
  return `A portfolio review compares properties that have a budget or an underwriting to be measured against. `
    + `${n === 0 ? 'None of yours has one yet' : 'Only one of yours has one'}; it needs at least ${min}.`;
}
